import {
  GET_PRICE_LIST_SHOWROOM,
  PUT_PRICE_LIST_SHOWROOM,
  SEARCH_PRICE_LIST_SHOWROOM,
  GET_PRICE_LIST,
  POST_PRICE_LIST,
  PUT_PRICE_LIST,
  DELETE_PRICE_LIST,
  SEARCH_PRICE_LIST,
  SYNCH_DATA_CONTENT
} from '../type'

const initialState = {
  listPriceShowroom: [],
  countPriceListShowroom: 0,
  listPrice: [],
  countPriceList: 0,
  searchListPrice: []
}

const priceList = ( state = initialState, action ) => {
  switch(action.type) {
    case GET_PRICE_LIST_SHOWROOM:
      return {
        ...state,
        listPriceShowroom: action.data.data,
        countPriceListShowroom: action.data.count
      }
    case PUT_PRICE_LIST_SHOWROOM:
      return {
        ...state,
        listPriceShowroom: state.listPriceShowroom.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case SEARCH_PRICE_LIST_SHOWROOM:
      return {
        ...state  
      }
    case GET_PRICE_LIST:
      return {
        ...state,
        listPrice: action.data.data,
        countPriceList: action.data.count
      }
    case POST_PRICE_LIST:
      return {
        ...state,
        listPrice: [...state.listPrice, action.data]
      }
    case PUT_PRICE_LIST:
      return {
        ...state,
        listPrice: state.listPrice.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_PRICE_LIST:
      return {
        ...state,
        listPrice: state.listPrice.filter(
          (item) => item._id !== action.data._id
        )
      }
    case SEARCH_PRICE_LIST:
      return {
        ...state,
        searchListPrice: action.data
      }
    case SYNCH_DATA_CONTENT:
      return {
        ...state,
        listPriceShowroom: state.listPriceShowroom.map(
          (item) => item._id === action.data.id_product ? { ...item, ...action.data } : item
        )
      }
    default:
      return state
  }
}

export default priceList